import MyApiClient from '../../api-client/MyApiClient';

// Action Types
export const FETCH_FEDERATIONS_REQUEST = 'FETCH_FEDERATIONS_REQUEST';
export const FETCH_FEDERATIONS_SUCCESS = 'FETCH_FEDERATIONS_SUCCESS';
export const FETCH_FEDERATIONS_FAILURE = 'FETCH_FEDERATIONS_FAILURE';
export const CLEAR_FEDERATIONS = 'CLEAR_FEDERATIONS';

// Action Creators
export const fetchFederationsRequest = () => ({
    type: FETCH_FEDERATIONS_REQUEST
});

export const fetchFederationsSuccess = (federations) => ({
    type: FETCH_FEDERATIONS_SUCCESS,
    payload: federations
});

export const fetchFederationsFailure = (error) => ({
    type: FETCH_FEDERATIONS_FAILURE,
    payload: error
});

export const clearFederations = () => ({
    type: CLEAR_FEDERATIONS
});

// Thunk Action
export const fetchFederations = (token, forceRefresh = false) => {
    return async (dispatch, getState) => {
        const state = getState();
        const { federations, loading, lastFetched } = state.federations;
        
        // Se i dati sono già presenti e non è passata un'ora, non fare la chiamata
        const oneHour = 60 * 60 * 1000; // 1 ora in millisecondi
        const shouldFetch = forceRefresh || 
                           federations.length === 0 || 
                           !lastFetched || 
                           (Date.now() - lastFetched) > oneHour;
        
        if (!shouldFetch && !loading) {
            return federations;
        }
        
        if (loading) {
            return;
        }
        
        dispatch(fetchFederationsRequest());
        
        try {
            const apiClient = new MyApiClient();
            const result = await apiClient.getFederations(token);
            
            if (result && result.error) {
                dispatch(fetchFederationsFailure(result.error));
                return null;
            }
            
            dispatch(fetchFederationsSuccess(result || []));
            return result;
        } catch (error) {
            console.error('Error fetching federations:', error);
            dispatch(fetchFederationsFailure('Errore durante il caricamento delle federazioni'));
            return null;
        }
    };
};